import { NameFormat } from '../../models/shared/Settings';

export const formatName = (name: string, format?: NameFormat) => {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!format || format === 'full' || parts.length === 0) {
        return name;
    }
    if (format === 'first-name-without-initials') {
        return parts[0];
    }
    if (format === 'initials') {
        return parts.map(part => `${part[0].toUpperCase()}.`).join(' ');
    }
    // 'first-name-only': first name kept, the rest abbreviated to initials
    return [parts[0], ...parts.slice(1).map(part => `${part[0].toUpperCase()}.`)].join(' ');
};
